import { createUnknownComponentVNode as _$cc, map as _$ma, createElementVNode as _$ce, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue-next';
import { DropdownMenu } from '../dropdown';
import { _$ } from '../../i18n';
import { makeMenuStyles } from './styles';
import { isEmptyChildren, eachChildren } from '../utils';
import { OptionGroup } from './group';
import { noop, isFunction } from 'intact-shared';
import { Input } from '../input';
import { Button } from '../button';
import { Icon } from '../icon';
import { context } from './useSearchable';
import { Tabs, Tab } from '../tabs';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className;
  var _this$select$get = this.select.get(),
    card = _this$select$get.card,
    searchable = _this$select$get.searchable,
    multiple = _this$select$get.multiple;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-select-menu"] = true, _classNameObj[k + "-card"] = card, _classNameObj[k + "-searchable"] = searchable, _classNameObj[className] = className, _classNameObj[makeMenuStyles(k)] = true, _classNameObj);
  if (card) {
    var _this$card = this.card,
      process = _this$card.process,
      activeIndex = _this$card.activeIndex;
    var _process = process(children),
      labels = _process.labels,
      group = _process.group;
    children = [_$cc(Tabs, {
      'vertical': true,
      'type': 'card',
      'value': activeIndex.value,
      'ev-$change:value': activeIndex.set,
      'children': _$ma(labels, function ($value, $key) {
        return _$cc(Tab, {
          'value': $key,
          'children': isFunction($value) /* is <b:label> block */ ? $value(noop) : $value
        });
      }, $this)
    }), group];
  }
  if (isEmptyChildren(children)) {
    children = _$ce(2, 'div', _$('无数据'), 0, _$cn(k + "-select-empty"));
  }
  if (searchable) {
    var _this$searchable = this.searchable,
      selectAll = _this$searchable.selectAll,
      toggleSelect = _this$searchable.toggleSelect,
      unselectAll = _this$searchable.unselectAll,
      confirm = _this$searchable.confirm,
      checkedKeys = _this$searchable.checkedKeys;
    var _this$select$input = this.select.input,
      onInput = _this$select$input.onInput,
      keywords = _this$select$input.keywords;
    var Provider = context.Provider;
    children = _$cc(Provider, {
      'value': checkedKeys,
      'children': [_$ce(2, 'div', [_$cc(Input, {
        'fluid': true,
        'size': 'small',
        'placeholder': _$('请输入关键字'),
        'value': keywords.value,
        'ev-$change:value': onInput,
        'clearable': true,
        'waveDisabled': true,
        '$blocks': function ($blocks) {
          var _$blocks = {},
            __$blocks = _$ex({}, $blocks);
          return (_$blocks['suffix'] = function ($super) {
            return _$cc(Icon, {
              'className': _$cn(k + "-icon-search")
            });
          }, __$blocks['suffix'] = function ($super, data) {
            var block = $blocks['suffix'];
            var callBlock = function callBlock() {
              return _$blocks['suffix'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }), __$blocks;
        }.call($this, _$em)
      }), multiple ? _$ce(2, 'div', [_$cc(Button, {
        'type': 'link',
        'size': 'small',
        'ev-click': selectAll,
        'children': _$('全选')
      }), _$cc(Button, {
        'type': 'link',
        'size': 'small',
        'ev-click': toggleSelect,
        'children': _$('反选')
      }), _$cc(Button, {
        'type': 'link',
        'size': 'small',
        'ev-click': unselectAll,
        'children': _$('清空')
      })], 4, _$cn(k + "-select-op")) : undefined], 0, _$cn(k + "-select-header")), _$ce(2, 'div', children, 0, _$cn(k + "-select-body")), multiple ? _$ce(2, 'div', [_$cc(Button, {
        'size': 'small',
        'ev-click': this.select.hide,
        'children': _$('取消')
      }), _$cc(Button, {
        'type': 'primary',
        'size': 'small',
        'ev-click': confirm,
        'children': _$('确定')
      })], 4, _$cn(k + "-select-footer")) : undefined]
    });
  }
  return _$cc(DropdownMenu, {
    'className': _$cn(classNameObj),
    'children': children
  });
}
;